import React from "react";
import "../HomePage.css";
import { CardMedia, CircularProgress } from "../../../common/MaterialComponent";
import { ErrorPage } from "../../ErrorPage/ErrorPage";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";

interface HomePageVideoProps {
	video?: string;
	error?: string;
}

export const HomePageVideo: React.FC<HomePageVideoProps> = ({
	video,
	error,
}) => {
	const strings = useGetComponentStringsContext().HomePage;

	return (
		<div>
			{error ? (
				<ErrorPage message={strings.errorMessage} />
			) : !video ? (
				<div className="loader">
					<CircularProgress size={50} />
				</div>
			) : (
				<>
					<div>
						<CardMedia component="video" src={video} title="video" controls />
					</div>
				</>
			)}
		</div>
	);
};
